import { render } from "./CompleteButton.vue?vue&type=template&id=21b640a6"
import script from "./CompleteButton.vue?vue&type=script&lang=ts"
export * from "./CompleteButton.vue?vue&type=script&lang=ts"
script.render = render

export default script